/* eslint-disable */

import 'jquery-hoverintent';

jQuery( function( $ ) {
	let $mobileButton = $( 'button.mobile-nav-toggle, .close-mobile-nav' ),
		$acMenu = $( '.ac-nav-collapse' );

	$mobileButton.on( 'click', ( e ) => {
		e.stopPropagation();
		$acMenu.toggleClass( 'mobile-open' );
		$( 'body' ).toggleClass( 'mobile-open' );
	});

	// Toggles submenus
	$( '.toggle-sub-menu' ).on( 'click', function() {
		$( this ).siblings( '.sub-menu-container, .sub-menu' ).toggleClass( 'show-sub-menu' );
		$( this ).toggleClass( 'sub-menu-open' );
		$( this ).parent().toggleClass( 'menu-opened' );
	});

	// Show or hide site overlay on megamenu hover
	const intentIn = function() {
		$( '.site-overlay' ).addClass( 'visible' );
		$( this ).addClass( 'open' );
	};

	const intentOut = function() {
		$( '.site-overlay' ).removeClass( 'visible' );
		$( this ).removeClass( 'open' );
	};

	$( '.megamenu' ).hoverIntent(
		{
			over: intentIn,
			out: intentOut,
			timeout: 150,
		}
	);

	// Close menu when clicking the AC Language Picker toggle
	$( '.top-header-mobile .aclp-toggle' ).on( 'click', () => {
		$( '.mobile-nav-toggle' ).trigger( 'click' );
	});

	/* eslint-enable */

	/**
	 * This function checks if current viewport is in mobile.
	 * Adds classes to auto trigger opened sub menus if it is a mega menu
	 *
	 * @param { Object } clickedElement jQuery object from click event.
	 */
	window.triggerMobileMenuOpen = function( clickedElement ) {
		const addClasses = function() {
			$( clickedElement ).siblings( '.sub-menu-container' ).children( 'ul' ).children( '.menu-item-has-children' ).children( '.toggle-sub-menu' ).trigger( 'click' );
		};

		if ( 'undefined' !== typeof navigator ) {
			// User agent can be modified so not 100% reliable
			if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent ) ) { // eslint-disable-line
				if ( $( clickedElement ).hasClass( 'menu-item-has-children' ) && 0 < $( clickedElement ).find( 'div.show-sub-menu ul li.menu-item-has-children' ).length ) {
					addClasses();
					return;
				}
			}
			// Not supported by all browsers "https://caniuse.com/?search=userAgentData"
			if ( 'undefined' !== typeof navigator.userAgentData ) { // eslint-disable-line
				if ( navigator.userAgentData.mobile ) { // eslint-disable-line
					addClasses();
					return;
				}
			}
		}

		// Fallback matching on viewport width this only triggers if phone is in portrait mode
		if ( window.matchMedia( '(max-width: 500px)' ).matches && window.innerWidth < window.innerHeight ) {
			addClasses();
		}
	};

	// Click trigger for megamenu item that depth of 1 with children inside of it.
	$( 'body' ).on( 'click', '.menu-item-has-children.megamenu > .toggle-sub-menu', function() {
		window.triggerMobileMenuOpen( this );
	} );
} );
